import { render, staticRenderFns } from "./newmember.vue?vue&type=template&id=4c344db1&scoped=true"
import script from "./newmember.vue?vue&type=script&lang=js"
export * from "./newmember.vue?vue&type=script&lang=js"
import style0 from "./newmember.vue?vue&type=style&index=0&id=4c344db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c344db1",
  null
  
)

export default component.exports